module.exports = __webpack_public_path__ + "img/galeria-04.660e3fcb.jpg";